// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bhp_j bhp_i bhp_bc bhp_r bhp_st","QualityCheckboxes__quality":"ex_b"};